import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Vice-Chancellor Message</h1>
                <p>Home &gt; Vice-Chancellor Message</p>
            </div>
        </div>
    );
};

export default Hero;
